import { FeatureEmptyState } from '@/shared/components/custom/FeatureEmptyState'
import { Button } from '@/shared/components/ui/button'
import { Film, ListVideo, Plus, Sparkles } from 'lucide-react'

const StoryboardNoFramesState = ({
    selectedShot,
    onToggleShotList,
    onInitiateFrameGeneration,
    onCreateManually,
}: {
    selectedShot: any
    onToggleShotList: () => void
    onInitiateFrameGeneration: (shot: any) => void
    onCreateManually: () => void
}) => {
    return (
        <FeatureEmptyState
            className=" bg-muted/5  h-[60vh] py-20"
            icon={<Film className="h-10 w-10 text-primary" />}
            title={selectedShot ? 'No Frame Yet' : 'Select a Shot'}
            description={
                selectedShot
                    ? "This shot doesn't have a frame yet. Generate one with AI or create it manually."
                    : 'To create a storyboard, please select a shot from the list on the right.'
            }
        >
            {!selectedShot && (
                <div className="flex gap-4">
                    <Button variant="outline" size="lg" onClick={onToggleShotList} className="px-8 flex items-center">
                        <ListVideo className="mr-2 h-5 w-5" />
                        Open Shot List
                    </Button>
                </div>
            )}

            {selectedShot && (
                <div className="flex gap-4">
                    <Button size="lg" onClick={() => onInitiateFrameGeneration(selectedShot)}>
                        <Sparkles className="mr-2 h-5 w-5" />
                        Generate with AI
                    </Button>
                    <Button variant="outline" size="lg" onClick={onCreateManually}>
                        <Plus className="mr-2 h-5 w-5" />
                        Create Manually
                    </Button>
                </div>
            )}
        </FeatureEmptyState>
    )
}

export default StoryboardNoFramesState
